(function (w) {
    const assetId = '~/theme/v1/Views/Menu/MegaMenu.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    w.umwAssets[assetId].forEach(ctx => {
        const prefixClass = "uc203-full-width";
        const classes = {
            control: "js-" + prefixClass,
            lvl1Item: "js-" + prefixClass + "-lvl1-item",
            popup: prefixClass + "-popup",
            lvl1ItemHovered: prefixClass + "-lvl1-item-hovered",
        };

        const desktopHeaderContainer = document.querySelector('.site-header-desktop');
        const control = document.querySelector("." + classes.control);
        if (!control) return; // Exit if control is not found

        let hoverTimerId;

        // Using event delegation for mouseenter and mouseleave
        control.addEventListener("mouseenter", handleMouseOver, true);
        control.addEventListener("mouseleave", handleMouseOut, true);

        function handleMouseOver(e) {
            if (!e.target.matches("." + classes.lvl1Item)) return;

            const beforeMegaMenuLvl1Mouseenter = new CustomEvent("megamenu:lvl1:beforemouseenter");
            control.dispatchEvent(beforeMegaMenuLvl1Mouseenter);
            if (beforeMegaMenuLvl1Mouseenter.defaultPrevented) return;

            clearTimeout(hoverTimerId);
            hoverTimerId = setTimeout(() => applyHoverState(e.target), 250);
        }

        function handleMouseOut(e) {
            if (!e.target.matches("." + classes.lvl1Item)) return;

            const beforeMegaMenuLvl1Mouseleave = new CustomEvent("megamenu:lvl1:beforemouseleave");
            control.dispatchEvent(beforeMegaMenuLvl1Mouseleave);
            if (beforeMegaMenuLvl1Mouseleave.defaultPrevented) return;

            clearTimeout(hoverTimerId);
            hoverTimerId = setTimeout(removeHoverState, 250);
        }

        function applyHoverState(target) {
            control.querySelectorAll("." + classes.lvl1Item).forEach(item => item.classList.remove(classes.lvl1ItemHovered));
            target.classList.add(classes.lvl1ItemHovered);
            adjustPopupIfNecessary(target);
        }

        function removeHoverState() {
            control.querySelectorAll("." + classes.lvl1Item).forEach(item => item.classList.remove(classes.lvl1ItemHovered));
            document.body.classList.remove('uc203-hovered');
        }

        function adjustPopupIfNecessary(target) {
            if (!target.classList.contains('has-submenu')) {
                document.body.classList.remove('uc203-hovered');
                return;
            }

            const hoveredLevel1PopupContainer = target.querySelector('.' + classes.popup);
            const heightHeaderAndMegaMenu = desktopHeaderContainer.clientHeight + hoveredLevel1PopupContainer.clientHeight;
            if (heightHeaderAndMegaMenu > window.innerHeight) {
                hoveredLevel1PopupContainer.classList.add('scrollable');
                hoveredLevel1PopupContainer.style.height = `calc(${window.innerHeight * .9 - desktopHeaderContainer.clientHeight}px)`;
            }
            document.body.classList.add('uc203-hovered');
        }
    });
})(window);